<template>
  <blob-panel>
    <h2 class="text-center">
      Two-factor authentication
    </h2>

    <form ref="form" @submit.prevent="submit">
      <div class="form-group u-mt-x-large" :class="{'has-error': error}">
        <label for="one_time_password">Confirm code</label>
        <input
          id="one_time_password"
          v-model="confirmCode"
          name="one_time_password"
          type="number"
          class="form-control"
          required
          autofocus
        >
        <span v-if="error" class="help-block" v-text="error" />
      </div>

      <div class="u-mt-x-large text-right">
        <button type="submit" class="btn btn--primary">
          <i v-if="isLoading" class="fas fa-spinner fa-spin fa-fw" />
          Continue
        </button>
      </div>
    </form>
  </blob-panel>
</template>

<script>

import { axios } from '@qlik-trial/automations-ui'
import isValid2FACode from '../../functions/isValid2FACode'
import { MessageLevel } from '@qlik-trial/automations-ui'

export default {
  data() {
    return {
      confirmCode: '',
      isLoading: false,
      errors: [],
    }
  },

  computed: {
    token() {
      return window && window.Laravel.csrfToken
    },

    error() {
      return this.errors && this.errors.message && this.errors.message[0]
    },
  },

  watch: {
    confirmCode(value) {
      if (isValid2FACode(value)) {
        this.submit()
      } else {
        this.isLoading = false
      }
    },
  },

  methods: {
    submit() {
      this.isLoading = true

      axios.post(
        '/2fa',
        { one_time_password: this.confirmCode, _token: this.token },
        { errorHandling: { 429: false } },
      )
        .then(() => window.location.reload())
        .catch(error => {
          this.isLoading = false

          this.errors = error.response.data

          if (error.response.status === 429) {
            this.flash({
              message: 'Too many requests have been made. Please try again later.',
              level: MessageLevel.WARNING,
            })
          }
        })
    },
  },
}
</script>
